'use client';

import type { ReactNode } from 'react';
import { requestPdMeasurement } from '../request.client';
import type { PdMeasurementRequestHandler, PrescriptionPdMeasurementRisk } from '../types';

interface PrescriptionPdMeasurementActionProps {
  label: string;
  onMeasure?: PdMeasurementRequestHandler;
  prescriptionRisk?: PrescriptionPdMeasurementRisk;
}

export function PrescriptionPdMeasurementAction({
  label,
  onMeasure,
  prescriptionRisk = 'standard',
}: PrescriptionPdMeasurementActionProps) {
  const handleClick = () => {
    const request = {
      kind: 'pd' as const,
      source: 'lens-prescription-pd' as const,
      prescriptionRisk,
    };
    if (onMeasure) {
      onMeasure(request);
      return;
    }

    requestPdMeasurement(request.source, window, request.prescriptionRisk);
  };

  return (
    <button
      type="button"
      className="flex cursor-pointer items-center gap-[2px] border-0 bg-transparent p-0 text-[12px] leading-[14px] text-primary-purple underline underline-offset-2"
      onClick={handleClick}
    >
      <svg
        aria-hidden
        className="size-[16px] shrink-0"
        focusable="false"
        viewBox="0 0 13 13"
        fill="none"
      >
        <path
          d="M5.67048 10.7937L4.5192 9.64244M7.39739 9.0668L5.80417 7.47358M9.1243 7.33989L7.97303 6.18861M10.8512 5.61297L9.258 4.01976M4.20263 12.2616L12.2616 4.20263C12.5795 3.88471 12.5795 3.36927 12.2616 3.05135L9.94865 0.738437C9.63073 0.420521 9.11529 0.420521 8.79737 0.738437L0.738437 8.79737C0.420521 9.11529 0.420521 9.63073 0.738437 9.94865L3.05135 12.2616C3.36927 12.5795 3.88471 12.5795 4.20263 12.2616Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>{label}</span>
    </button>
  );
}

interface PrescriptionPdHistoryNoticeProps {
  children: ReactNode;
}

export function PrescriptionPdHistoryNotice({ children }: PrescriptionPdHistoryNoticeProps) {
  return (
    <div
      role="status"
      className="w-full whitespace-pre-line rounded-[4px] bg-[#fff9d7] p-[8px] text-[11px] leading-[normal] text-primary-black"
    >
      {children}
    </div>
  );
}
